@if(showSpinner) {
  <div class="spinner-overlay">
    <ion-spinner name="bubbles" color="danger"></ion-spinner>
</div>
}